import React, { useEffect, useRef } from 'react';

//Material UI
import { Box, Button, Grid } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

//Zustands
import { useMainStore } from 'useStores/useMainStore';
import { useOnlineUsersStore } from './useOnlineUsersStore';

//APIs
import { getOnlineUsers } from 'useReactQueries/useOnlineUsers';

//Packages
import moment from 'moment-jalaali';
import { useMutation, useQuery } from 'react-query';
import { isMobile } from 'react-device-detect';

//Components
import DatePicker from 'components/TextFields/DatePicker';
import Accordion from '../../../../../components/Accordion/Accordion';

const useStyles = makeStyles((theme) => ({
  searchButton: {
    width: 150,
  },
}));

const Filters = () => {
  const classes = useStyles();
  const changeCheckBox = useOnlineUsersStore((state) => state.changeCheckBox);
  const filters = useOnlineUsersStore((state) => state.filters);
  const isCustomerChecked = useOnlineUsersStore(
    (state) => state.filters.customer
  );
  const isDriverChecked = useOnlineUsersStore((state) => state.filters.driver);
  const page = useOnlineUsersStore((state) => state.page);
  const changeStartDate = useOnlineUsersStore((state) => state.changeStartDate);
  const changeEndDate = useOnlineUsersStore((state) => state.changeEndDate);
  const startDate = useOnlineUsersStore((state) => state.startDate);
  const endDate = useOnlineUsersStore((state) => state.endDate);
  const setUsers = useOnlineUsersStore((state) => state.setUsers);
  const isLoading = useOnlineUsersStore((state) => state.isLoading);
  const setLoading = useOnlineUsersStore((state) => state.setLoading);
  const setTotalCustomers = useOnlineUsersStore(
    (state) => state.setTotalCustomers
  );
  const limit = useMainStore((state) => state.limit);
  const firstRender = useRef(true);

  const { mutate } = useMutation(getOnlineUsers, {
    onSuccess: (result) => {
      setUsers(result);
      setTotalCustomers(result.totalDocs);
      setLoading(false);
    },
    onMutate: () => {
      setLoading(true);
    },
  });

  // const handleCheckboxChange = (e) => {
  //   const { name, checked } = e.target;
  //   changeCheckBox(name, checked);
  // };

  const handleClickSearchButton = () => {
    mutate({
      page,
      limit,
      from: moment(startDate)?.format('YYYY-MM-DD'),
      to: moment(endDate)?.format('YYYY-MM-DD'),
      roles: ['customer'],
    });
  };

  useEffect(() => {
    if (firstRender.current) {
      handleClickSearchButton();

      firstRender.current = false;
    } else {
      handleClickSearchButton();
    }
  }, [page, limit]);

  return (
    <Accordion title="فیلترها" open={isMobile ? false : true}>
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12} md={4} className="d-flex " style={{ gap: 8 }}>
          <DatePicker
            label="ازتاریخ"
            value={startDate}
            onChange={(e) => changeStartDate(e)}
          />
          <DatePicker
            label="تا‌تاریخ"
            value={endDate}
            onChange={(e) => changeEndDate(e)}
          />
        </Grid>

        {/* <Grid item xs={8} md={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCustomerChecked}
                onChange={handleCheckboxChange}
                name="customer"
                color="primary"
              />
            }
            label="صاحبین بار"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isDriverChecked}
                onChange={handleCheckboxChange}
                name="driver"
                color="primary"
              />
            }
            label="رانندگان"
          />
        </Grid> */}
        <Grid item justify="flex-end" className="d-flex" xs={4} md={4}>
          <Box className={classes.spacer} />
          <Button
            color="secondary"
            variant="contained"
            className={classes.searchButton}
            onClick={handleClickSearchButton}
            disabled={isLoading}
          >
            {isLoading ? 'در حال جستجو ...' : 'جستجو'}
          </Button>
        </Grid>
      </Grid>
    </Accordion>
  );
};

export default Filters;
